
;(function ( $, window, document, undefined ) {

    var pluginName = 'beInvoices',
        defaults = {
            propertyName: "value"
        };

    // The actual plugin constructor
    function Plugin( element, options ) {
        this.element = element;
        this.$element = $(element);
        this.options = $.extend( {}, defaults, options) ;
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    Plugin.prototype.init = function () {
        var Plugin = this;
        Plugin.setEvents();
    };


    Plugin.prototype.setEvents = function () {
        $('#external-invoices').on('bw.Error', function (e, data) {
            console.log(data);
            if(typeof data.responseJSON.euro_exchange_rate != 'undefined'){
                console.log('1----------');
                $('.js-euro_exchange').removeClass('hide');
            }
        })
    }



    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[pluginName] = function ( options ) {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName,
                    new Plugin( this, options ));
            }
        });
    }

})( jQuery, window, document );